import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Developer } from '@app/interfaces';
import { DeveloperService } from '@app/services';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'mnf-authentication-fourth-screen',
  templateUrl: './authentication-fourth-screen.component.html',
  styleUrls: ['./authentication-fourth-screen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthenticationFourthScreenComponent implements OnInit {

  @Output() form = new EventEmitter();
  @Output() returnStep = new EventEmitter();
  @Input() set user(u: Developer) {
    this.developer = u;
  }

  /** Variable global de developer */
  developer: Developer;

  /** Inicializar formulario  */
  fourthFormDev: FormGroup;

  /** Valores Si o No */
  defaultOptions = ['Si', 'No'];
  
  /** Valores de options de capital requerido */
  requiredCapitalOptions = ['0-10MDP (Bajo)', '10-MDP (Medio)', '40MDP+ (Alto)'];

  /** Valores de options de objeto financiero */
  purposeFinancingOptions = ['Construcción', 'Remodelación', 'Mejorar operación', 'Otros'];

  /** Valores de estado actual del hotel */
  stateHotelOptions = ['Construccion', 'Operacion'];

  /** Valores de options de ingresos en el último año */
  income12MonthsOptions = [
    { value: '$3 - $5 MDP MXN'  },
    { value: '$6 - $10 MDP MXN'  },
    { value: '$11 - $15 MDP MXN' },
    { value: '$16 - $20 MDP MXN' },
    { value: '$21 - $30 MDP MXN' },
    { value: '$30 - $50 MDP MXN'},
    { value: '+ $50 MDP MXN'},
    { value: 'Otros' }
  ];

  /** Valores de drag and drop de razones */
  reasons = [
    'Liquidez',
    'Construir más hoteles',
    'Encontrar socios inversionistas',
    'Recuperar inversión'
  ]
  
  /** Nombre completo del usuario */
  fullName: string;

  /** Pasos del formulario */
  step = 1;

  /** Email */
  email: string;

  /** @Get form */
  get forms() {
    return this.fourthFormDev.controls;
  }

  constructor(private developServ: DeveloperService) {}

  ngOnInit(): void {

    // Asignar email
    this.email = this.developer.email;

    this.fullName = this.developer.name + ' ' + this.developer.fatherSurname + ' ' + this.developer.motherSurname;

    /** Incializar formulario */
    this.fourthFormDev = new FormGroup({
      isLegalRepresentative: new FormControl(this.developer?.developer?.isLegalRepresentative || '', Validators.compose([Validators.required])),
      name: new FormControl(this.developer?.name || '', Validators.compose([Validators.minLength(3), Validators.maxLength(25)])),
      fatherSurname: new FormControl(this.developer?.fatherSurname || '', Validators.compose([Validators.minLength(3), Validators.maxLength(25)])),
      motherSurname: new FormControl(this.developer?.motherSurname || '', Validators.compose([Validators.minLength(3), Validators.maxLength(25)])),
      stateHotel: new FormControl(this.developer?.developer?.stateHotel || '', [Validators.compose([Validators.required])]),
      income12Months: new FormControl(this.developer?.developer?.income12Months || '', Validators.compose([Validators.required])),
      income12MonthsOthers: new FormControl(this.developer?.developer?.income12MonthsOthers || '', Validators.compose([Validators.minLength(3), Validators.maxLength(12)])),
      isOperator: new FormControl(this.developer?.developer?.isOperator || '', Validators.compose([Validators.required])),
      operationYears: new FormControl(this.developer?.developer?.operationYears || '', Validators.compose([Validators.minLength(2), Validators.maxLength(4)])),
      requiredCapital: new FormControl(this.developer?.developer?.requiredCapital || '', Validators.compose([Validators.required])),
      purposeFinancing: new FormControl(this.developer?.developer?.purposeFinancing || '', Validators.compose([Validators.required])),
      purposeFinancingOthers: new FormControl(this.developer?.developer?.purposeFinancingOthers || '', Validators.compose([Validators.minLength(5), Validators.maxLength(50)])),
    })

  }


  nextStep() {
    
    const requests: { info?: any } = {};

    const infoToSend = this.fourthFormDev.value;

    if(infoToSend.isLegalRepresentative === 'Si') {

      requests.info = this.developServ.updateInfoDevStepTwo(infoToSend, this.email);

      forkJoin(requests).subscribe((r: { info?: any }) => {
        this.form.next(r.info);
      })
    } else {
      requests.info = this.developServ.updateInfoDevStepTwoName(infoToSend, this.email);

      forkJoin(requests).subscribe((r: { info?: any }) => {
        this.form.next(r.info);
      })
    }

  }


  returnToStep() {
    this.returnStep.next(2);
  }

}
